import Title from '@/components/InspectionReport/Items/Questions/Title';
import Response from '@/components/InspectionReport/Items/Questions/Response';
import ImageDrawing from '@/components/InspectionReport/Items/Questions/ImageDrawing.vue';

export default {
    functional: true,
    props: {
        item: {
            type: Object,
            required: true,
        },
        resource: {
            type: Object,
            default: null,
        },
    },
    render(h, {
        props, data, parent, _v,
    }) {
        let selectedResponses = '';

        if (props.item.responded === true && props.item.response) {
            selectedResponses = props.resource.form.params.response_sets
                .find(({ uuid }) => (uuid === props.item.params.response_set))
                .responses
                .filter(({ uuid }) => (props.item.response.includes(uuid)))
                .map((response) => response.title)
                .join(', ');
        }

        const childs = [
            h(Title, {}, props.item.title),
            h(Response, { props: { responded: props.item.responded === true } }, selectedResponses),
        ];

        if (props.item.notes) {
            childs.push(h('div', { class: 'mt-3 mb-6' }, [
                h('h4', { class: 'mt-0 text-70 font-normal mb-1' }, parent.$t('Notes')),
                h('div', { class: 'whitespace-pre-line' }, props.item.notes),
            ]));
        }

        if (props.item.photos && props.item.photos.length > 0) {
            childs.push(h('div', { class: 'mt-3 mb-6' }, [
                h('h4', { class: 'mt-0 text-70 font-normal mb-1' }, parent.$t('Photos')),
                props.item.photos.map(({ image, drawing }) => h(
                    ImageDrawing,
                    {
                        style: 'max-height: 200px;',
                        class: 'mr-3 mb-3 inline-block',
                        props: { image, drawing },
                    },
                )),
            ]));
        }

        return h(
            'div',
            data,
            childs,
        );
    },
};
